import { render, staticRenderFns } from "./AvisoPendiente.vue?vue&type=template&id=207ed3ce&"
import script from "./AvisoPendiente.vue?vue&type=script&lang=js&"
export * from "./AvisoPendiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports